namespace GeniuzPOS.ReportMasterData {
    export class Report_1314Columns {
        static columnsKey = 'ReportMasterData.Report_1314';
    }
}
